import 'babel-polyfill';
import { LOGIN } from '_constants';
import { redirectToRoute } from './common.actions';
import _ from 'lodash';
import { showServerResponse } from './modals.actions';
import { isResponseSuccess } from 'helpers';
import { LoginApiProvider } from '../services/login.services';

const fetchMethods = (userName) => async (dispatch) => {
  try {
    dispatch({ type: LOGIN.START_RESET_ACTION });
    const response = await dispatch(LoginApiProvider.fetchMethods(userName));
    dispatch({ type: LOGIN.FETCH_AVAILABLE_METHODS, payload: response || [] });
    return response;
  } catch (err) {
    console.error(err);
    dispatch({ type: LOGIN.PASSWORD_RESET_ERROR, payload: err.response.data });
    return Promise.reject(err);
  } finally {
    dispatch({ type: LOGIN.END_RESET_ACTION });
  }
};

const sendValidationCode = (validation) => async (dispatch, getState) => {
  try {
    dispatch({ type: LOGIN.START_RESET_ACTION });
    const response = await dispatch(LoginApiProvider.sendValidationCode(validation));
    const confirmationMessage = LOGIN.SEND_CONFIRMATION + _.get(getState(), 'login.sendMethod.maskedDestination', '');
    dispatch({ type: LOGIN.SEND_CODE_VIA_METHOD, payload: response || {} });
    if (!isResponseSuccess(response)) {
      dispatch({ type: LOGIN.PASSWORD_RESET_ERROR, value: true });
    } else {
      dispatch(showServerResponse(response, confirmationMessage));
    }
    return response;
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  } finally {
    dispatch({ type: LOGIN.END_RESET_ACTION });
  }
};

const validateCode = (code) => async (dispatch) => {
  try {
    dispatch({ type: LOGIN.START_RESET_ACTION });
    const response = await dispatch(LoginApiProvider.validateCode(code));
    dispatch({ type: LOGIN.SET_VALIDATION_CODE, value: code.validationCode || '' });
    dispatch({ type: LOGIN.CODE_VALIDATION, payload: response });
    return response;
  } catch (err) {
    console.error(err);
    dispatch({ type: LOGIN.PASSWORD_RESET_ERROR, payload: err.response.data });
    return Promise.reject(err);
  } finally {
    dispatch({ type: LOGIN.END_VALIDATING_CODE });
  }
};

const sendNewCredentials = (credentials) => async (dispatch) => {
  try {
    dispatch({ type: LOGIN.START_RESET_ACTION });
    const response = await dispatch(LoginApiProvider.sendNewCredentials(credentials));
    if (!isResponseSuccess(response)) {
      dispatch({ type: LOGIN.PASSWORD_RESET_ERROR, value: true });
    } else {
      dispatch(showServerResponse(response, LOGIN.PASSWORD_CHANGED));
    }
    return response;
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  } finally {
    dispatch({ type: LOGIN.END_RESET_ACTION });
  }
};

const setFormPosition = (position) => (dispatch) => {
  return dispatch({ type: LOGIN.SET_FORM_POSITION, value: position });
};

const setSendMethod = (method) => (dispatch) => {
  return dispatch({ type: LOGIN.SET_SEND_METHOD, value: method });
};

const setExpirationTime = (expirationTime) => (dispatch) => {
  return dispatch({ type: LOGIN.SET_SEND_TIME, value: expirationTime });
};

export const logout = () => dispatch => {
  localStorage.clear();
  dispatch({ type: LOGIN.LOGOUT });
  dispatch(redirectToRoute('/', { showHeader: false }));
};

export const acceptTerms = () => dispatch => {
  localStorage.setItem('isTermsAccepted', true); // TODO consolidate these duplicate values in service worker
  dispatch({ type: LOGIN.ACCEPT_LOGIN_TERMS });
};

/**
 *
 * @param {*} os
 * @returns {*} deviceType //1: Unsupported, 2: iOS, 3: Android
 */
const getDeviceType = (os) => {
  if (!os) { return 1; }
  switch (os.toString().toLowerCase()) {
    case 'ios':
      return 2;
    case 'android':
      return 3;
    default:
      return 1;
  }
};

export const updateDeviceInfo = (info) => (dispatch) => {
  if (!info) { return; }
  // dispatch({ type: LOGIN.UPDATE_DEVICE_INFO, deviceId: info.token, deviceType: getDeviceType(info.os), appVersion: info.version });
  const clientDeviceInfo = { type: LOGIN.UPDATE_DEVICE_INFO, deviceId: info.token, deviceType: getDeviceType(info.os), appVersion: '1.2.0' };
  localStorage.setItem('clientDeviceInfo', JSON.stringify(clientDeviceInfo));
  dispatch(clientDeviceInfo);
};

export const loginActions = {
  fetchMethods,
  sendValidationCode,
  validateCode,
  sendNewCredentials,
  setFormPosition,
  setExpirationTime,
  setSendMethod
};
